import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Loading from "../../Common/Loading";
import CustomAlert from "../../Common/CustomAlert";

const API_BASE_URL =
  process.env.REACT_APP_DOCUMENT_LINK || "https://staging.sysadmin.elearnoncloud.com/";

const NavigationReport: React.FC = () => {
  return (
    <div>NavigationReport</div>
  )
};

export default NavigationReport;
